import { useHistory } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { AdasBox, AdasTypography } from '@components/wrapper-components'
import { Card, Eyebrow, OutlineButton } from './BillingUi'

/**
 * What PrivateRoute renders in place of a page an admin has switched off for the active center
 * (Settings → Platform Features, CAR-4038). Not an upgrade case, so no Billing pitch: only an
 * administrator can turn it back on.
 */
export const FeatureDisabled = () => {
  const history = useHistory()

  return (
    <AdasBox className='mx-auto mt-10 max-w-[560px]'>
      <Card className='px-8 py-10 text-center'>
        <AdasBox className='mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted'>
          <Lock className='h-5 w-5 text-muted-foreground' aria-hidden='true' />
        </AdasBox>
        <Eyebrow className='mb-2'>Not turned on</Eyebrow>
        <AdasTypography className='text-[20px] font-bold text-foreground'>This feature isn’t turned on for this location</AdasTypography>
        <AdasTypography className='mx-auto mt-2 max-w-[440px] text-[14px] text-muted-foreground'>
          Ask your administrator to turn it on.
        </AdasTypography>
        <AdasBox className='mt-6 flex flex-wrap justify-center gap-3'>
          <OutlineButton onClick={() => history.push('/')}>Back to Home</OutlineButton>
        </AdasBox>
      </Card>
    </AdasBox>
  )
}
